import React from 'react';

import StatusPanel from '../StatusPanel';

interface IAgentImportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const AgentImport: React.FC<IAgentImportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Agent: Import" loading={loading} visible={visible} onClose={onClose} />;
};

export default AgentImport;
